module.exports = __webpack_public_path__ + "media/images/pic/anime/envelope-ad823bdd8646745d1788147352192563.svg";